import styled from 'styled-components';

export const SliderWrapper = styled.div`
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  cursor: pointer;
`;

interface SliderImageWrapperProps {
  isActive: boolean;
}

export const SliderImageWrapper = styled.div<SliderImageWrapperProps>`
  opacity: ${(props) => (props.isActive ? 1 : 0.6)};
  margin-right: 2px;

  &:hover {
    opacity: 1;
  }
`;
